<template>
  <div class="vertical-list">
    <h2 class="tittle">{{ title }}</h2>
    <swiper
      :modules="modules"
      navigation
      :slides-per-view="slidesPerView"
      :space-between="20"
      :pagination="false"
      :scrollbar="false"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="(asset, i) in assets" v-bind:key="i">
        <vertical-card :type="type" :asset="asset" :position="i" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import VerticalCard from "@/components/landing/carousel/VerticalCard.vue";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper";

export default {
  name: "VerticalCarousel",
  components: {
    VerticalCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    hidrated: {
      type: Boolean,
      default: false,
    },
    assets: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
    show_navigation: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    slidesPerView() {
      if (this.isMobile()) {
        return 2;
      } else {
        if (this.visibleImageCount > this.assets.length) {
          return this.assets.length - 1;
        }
        return this.visibleImageCount;
      }
    },
    showNavigation() {
      if (this.isMobile()) {
        return false;
      }
      return this.show_navigation;
    },
  },
  mounted() {
    this.updateVisibleImageCount();
    window.addEventListener("resize", this.updateVisibleImageCount);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateVisibleImageCount);
  },
  data() {
    return {
      isVisible: false,
      limit: 80,
      start: 0,
      visibleImageCount: 5,
    };
  },
  methods: {
    updateVisibleImageCount() {
      const width = window.innerWidth;

      if (width <= 1440) {
        this.visibleImageCount = 5; // Mínimo para resoluciones <= 1440px
      } else if (width <= 3840) {
        // Escala entre 1440 y 3840
        this.visibleImageCount = Math.ceil(
          5 + ((width - 1440) / (3840 - 1440)) * (10 - 5)
        );
      } else {
        this.visibleImageCount = 14; // Máximo para resoluciones >= 3840px
      }
    },
    visibilityChanged(isVisible) {
      if (!this.isVisible) {
        this.isVisible = isVisible;
      }
    },
    onSwiper(swiper) {},
    onSlideChange() {},
    onSwiperReachEnd(swiper) {},
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>

<style scoped lang="scss">
.tittle {
  font-weight: 400;
  margin: 1.5em 0 1.5em 0.5em;
}
</style>
